<template>
  <base-modal class="device-availability-modal"
              :show="show"
              @close="close"
              size="small">
    <div v-if="!fromBus.screentimeExhausted"
         slot="header">
      {{ $t("deviceAvailability.title2") }}:
    </div>

    <div v-else
         slot="header">
      {{ $t("deviceAvailability.screenTimeExhausted") }}!
    </div>

    <div>
      <device-availability :child-id="fromBus.childId"
                           :schedule-created="fromBus.scheduleCreated"
                           :show-schedule-btn="fromBus.showScheduleBtn"
                           @close="close" />
    </div>
  </base-modal>
</template>

<script>
  import DeviceAvailability from '@/components/Child/ChildDeviceAvailability/DeviceAvailability'
  import modalMixin from '@/mixins/modalMixin.js'

  export default {
    mixins: [
      modalMixin
    ],

    components: {
      DeviceAvailability
    },

    data() {
      return {
        fromBus: {
          childId: '',
          scheduleCreated: false,
          screentimeExhausted: false,
          showScheduleBtn: true
        }
      }
    },

    beforeMount() {
      this.setOpenListener('deviceAvailability')
    }
  }
</script>

<style lang="scss" scoped>
  .device-availability-modal {
    :deep(.modal-body) {
      max-height: 720px;
    }
  }
</style>
